
module.exports = {
    VOTE_NONE: 1,
    VOTE_UP: 2,
    VOTE_DOWN: 3,
    EDITABLE_DURATION: 480000,
    CACHE_CONTROL: 'no-cache, no-store, must-revalidate',
    MAX_NEST_LEVEL: 10,
    MAX_COMMENT_SIZE: 16384,
    MODE_DEFAULT: 'default',
    MODE_EDIT: 'edit',
    MODE_REPLY: 'reply',
    MODE_DELETE: 'delete',
    MODE_PROFILE: 'profile',
    MODE_BLOCK: 'block',
    MODE_HISTORY: 'history'
};


// WEBPACK FOOTER //
// ./src/utils/constants.js